import React, {createContext, useCallback, useContext, useEffect, useState} from "react";
import {ScreenConfig} from "../config/ScreenConfig";
import {useProjectorValidator} from "./rules/useProjectorValidator";
import {useProjectorPosition} from "./rules/useProjectorPosition";
import {useScreenSize} from "./rules/useScreenSize";
import {useScreenValidator} from "./rules/useScreenValidator";
import {useUserConfigContext} from "./UserConfigContext";

export const ScreenConfigContext = createContext({});

export default function ScreenConfigProvider({children}) {

    let defaultAspectRatio = 0;
    let defaultProjector = ScreenConfig.epson_qb_1000B;
    let defaultScreenSize = 250;
    let defaultProjectorType = "Front";

    const { userConfig } = useUserConfigContext();

    if (userConfig) {
        const config = userConfig;

        defaultScreenSize = config.screenSize;

        if (config.aspectRatio === "21:9") {
            defaultAspectRatio = 1;
        }


        if (config.screenId === "epson_qb_1000B") {
            defaultProjector = ScreenConfig.epson_qb_1000B;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "epson_ls_12000") {
            defaultProjector = ScreenConfig.epson_ls_12000;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "epson_ls_12000w") {
            defaultProjector = ScreenConfig.epson_ls_12000w;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "jvc_nz500") {
            defaultProjector = ScreenConfig.jvc_nz500;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "jvc_nz700") {
            defaultProjector = ScreenConfig.jvc_nz700;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "jvc_nz800") {
            defaultProjector = ScreenConfig.jvc_nz800;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "jvc_nz900") {
            defaultProjector = ScreenConfig.jvc_nz900;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "sony_vplxw5000es") {
            defaultProjector = ScreenConfig.sony_vplxw5000es;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "sony_vplxw5000esw") {
            defaultProjector = ScreenConfig.sony_vplxw5000esw;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "sony_vplxw6100es") {
            defaultProjector = ScreenConfig.sony_vplxw6100es;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "sony_vplxw6100esw") {
            defaultProjector = ScreenConfig.sony_vplxw6100esw;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "sony_vplxw8100es") {
            defaultProjector = ScreenConfig.sony_vplxw8100es;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "sony_vplxw8100esw") {
            defaultProjector = ScreenConfig.sony_vplxw8100esw;
            defaultProjectorType = "Front";
        }
        else if (config.screenId === "epson_ls800") {
            defaultProjector = ScreenConfig.epson_ls800;
            defaultProjectorType = "UST";
        }
        else if (config.screenId === "awol_ltv3000pro") {
            defaultProjector = ScreenConfig.awol_ltv3000pro;
            defaultProjectorType = "UST";
        }
        else if (config.screenId === "awol_ltv3500pro") {
            defaultProjector = ScreenConfig.awol_ltv3500pro;
            defaultProjectorType = "UST";
        }
        else if (config.screenId === "samsung_lsp7t") {
            defaultProjector = ScreenConfig.samsung_lsp7t;
            defaultProjectorType = "UST";
        }
        else if (config.screenId === "samsung_lsp9t") {
            defaultProjector = ScreenConfig.samsung_lsp9t;
            defaultProjectorType = "UST";
        }
    }

    let [ config, setConfig ] = useState(defaultProjector);
    let [ aspectRatio, setAspectRatio ] = useState(config.aspectRatios[defaultAspectRatio]);
    let [ acousticTransparent, setAcousticTransparent ] = useState(false);
    let [ projectorType, setProjectorType ] = useState(defaultProjectorType);

    const setConfigID = useCallback(id => setConfig(ScreenConfig[id]), []);
    const [ screenSize, setScreenSize ] = useScreenSize(config, defaultScreenSize);

    const projectorPosition = useProjectorPosition(config, screenSize);
    const [ screenFloorDistance, setScreenFloorDistance] = useState(50);
    const { score: projectorScore, errorCodes: projectorErrorCodes } = useProjectorValidator(config, screenSize, projectorPosition);
    const { score: screenScore, errorCodes: screenErrorCodes } = useScreenValidator(aspectRatio, config.screenRange, screenFloorDistance, screenSize);

    // when changing configs, make sure current aspect ratio is supported
    useEffect(() => {
        if (config.aspectRatios.indexOf(aspectRatio) < 0)
            setAspectRatio(config.aspectRatios[0]);
    }, [aspectRatio, config]);

    return (
        <ScreenConfigContext.Provider value={{
            screenSize, setScreenSize,
            aspectRatio, setAspectRatio,
            projectorType, setProjectorType,
            acousticTransparent, setAcousticTransparent,
            ...config, setConfigID,
            projectorPosition,
            projectorScore, projectorErrorCodes,
            screenScore, screenErrorCodes,
            screenFloorDistance, setScreenFloorDistance
        }}>
            {children}
        </ScreenConfigContext.Provider>
    );
}

export const useScreenConfig = () => useContext(ScreenConfigContext);
